'use strict';

import {keys} from 'ts-transformer-keys';
import _ from 'lodash';

import Item, {ItemOnlyJsonAttributes} from '~/shared/src/ci/Item';
import {FilterValueType} from '~/shared/src/validationSchemes/modules/overview';
import {renderValue} from '~/shared/src/utilities/valueRenderers';

import dbDefinitionMapper from '~/backend/src/connectors/db/dbDefinitionMapper';


const allowedAttributes = ( keys<ItemOnlyJsonAttributes>() as string[] ).concat( 'attributesModified' );

class ItemTemplateStringResolver {
    rawMode : boolean = false;

    protected _item : Item;

    constructor( item : Item ) {
        this._item = item;

        return new Proxy( this, this );
    }

    set( target : ItemTemplateStringResolver, attribute : string, value : any ) {
        let retVal = false;

        if ( attribute === 'rawMode' ) {
            retVal = true;
            this.rawMode = !!value;
        }

        return retVal;
    }

    get( target : ItemTemplateStringResolver, attribute : Symbol ) : ( () => string );
    get( target : ItemTemplateStringResolver, attribute : string ) : string;
    get( target : ItemTemplateStringResolver, attribute : string | Symbol ) : string | ( () => string ) {
        let retVal : string | ( () => string ) = '';

        if ( typeof attribute === 'symbol' ) {
            if ( attribute === Symbol.toPrimitive ) {
                retVal = () => {
                    return 'item';
                };
            }
        }
        else {
            retVal = attribute as string;

            attribute = _.lowerFirst( attribute as string );

            if ( allowedAttributes.includes( attribute ) ) {
                const rawValue = this._item[ attribute as keyof ItemOnlyJsonAttributes ];

                if ( rawValue !== undefined && rawValue !== null && rawValue !== '' ) {
                    retVal = renderValue( dbDefinitionMapper.schemas[ this._item.schema ].views[ 'item' ].getFieldType( attribute ) as FilterValueType, rawValue, undefined, this.rawMode ) as string;
                }
                else {
                    retVal = '';
                }
            }
            else if ( attribute === 'typeId' ) {
                retVal = String( this._item.itemTypeId );
            }
            else if ( attribute === 'itemTypeName' || attribute === 'typeName' ) {
                retVal = !this.rawMode ? this._item.itemType.label : this._item.itemType.name;
            }
            else if ( attribute === 'statusName' ) {
                retVal = !this.rawMode ? this._item.status.label : this._item.status.name;
            }
            else if ( attribute === 'displayAttributeValue' ) {
                retVal = String( this._item.displayAttributeValue );
            }
        }

        if ( !retVal && attribute !== 'name' ) {
            retVal = `item.${String( attribute )}`;
        }

        return retVal;
    }
}

export default ItemTemplateStringResolver;
